module.exports = __webpack_public_path__ + "img/VALORES.034cf1ec.jpg";